// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"13":"0c428ae2","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"13":"496180fe0f8171a50565","532":"708bdce5097da0262073","678":"5a8f8738ff2489f15fa2","883":"a5e4d9995ce993da7f78"}[chunkId] + ".js";
};